// ContextProviders.jsx

import { NotificationProvider } from "./Notifications/NotificationProvider";
import { DataProvider } from "./DataProviders/DataProvider";
import { ConnectedAppsProvider } from "./OrderSubmission/ConnectedAppsProvider";
import { ProfileStatusProvider } from "./Notifications/ProfileStatusProvider";
import { UploadProvider } from "./OrderSubmission/UploadContext";
import PropTypes from "prop-types";
import { SidebarProvider } from "./Sidebar/SidebarContext";
import { DomainProvider } from "./AutomationProvider/DomainProvider";
import { GuidedTourProvider } from "./GuidedTourContext/GuidedTourContext";
import { Box } from "@mui/material";
import { ManualOrderProvider } from "./ManualOrderContext/ManualOrderProvider";
import { ProfileSettingProvider } from "./ProfileSettingContext/ProfileSettingContext";
import { SupportProvider } from "./SupportProvider/SupportProvider";
import { GlobalSnackbarProvider } from "./GlobalSnackbarProvider/GlobalSnackbarProvider";
import { BulkOrderProvider } from "./BulkOrderProvider/BulkOrderProvider";
import { PrewarmProvider } from "./PrewarmProvider/PrewarmProvider";
import { SequencerProvider } from "./SequencerProvider/SequencerProvider";
import { ThemeProvider } from "./ThemeProvider/ThemeProvider";
const AppProviders = ({ children }) => (
  <ThemeProvider>
    <GlobalSnackbarProvider>
      <SidebarProvider>
        <DataProvider>
          <ProfileStatusProvider>
            <NotificationProvider>
              <UploadProvider>
                <ConnectedAppsProvider>
                  <DomainProvider>
                    <SupportProvider>
                      <GuidedTourProvider>
                        <ManualOrderProvider>
                          <BulkOrderProvider>
                            <PrewarmProvider>
                              <SequencerProvider>
                                <ProfileSettingProvider>
                                  <Box
                                    sx={{
                                      overflow: "hidden",
                                    }}
                                  >
                                    {children}
                                  </Box>
                                </ProfileSettingProvider>
                              </SequencerProvider>
                            </PrewarmProvider>
                          </BulkOrderProvider>
                        </ManualOrderProvider>
                      </GuidedTourProvider>
                    </SupportProvider>
                  </DomainProvider>
                </ConnectedAppsProvider>
              </UploadProvider>
            </NotificationProvider>
          </ProfileStatusProvider>
        </DataProvider>
      </SidebarProvider>
    </GlobalSnackbarProvider>
  </ThemeProvider>
);

// Add prop validation
AppProviders.propTypes = {
  children: PropTypes.node.isRequired, // Ensure children prop is provided
};

export default AppProviders;
